import React from "react";
import "./Gading.scss";
import data from "../Gading/data.json";
import Card from "../../Component/Card Gading/cardgading";
import Gadingimages from "../../media/Gading/Gading";

const imageMap = {
  Gadingimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="gading" className="produk">
      <div className="cardhome-containerviola">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
